//TODO: ESTE COMPONENTE TIENE QUE DESAPARECER, TIENE QUE USARSE SIEMPRE EL DE EmailDialog Y COMPROBAR SI ES O NO BULK.
import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  CustomButton,
} from '../../../common';
import EmailComposeView from './EmailComposeView';
import { capitalizeWords, getMostRecentCoupon } from '../utils/couponsMailsUtils';

const BulkSendConfirmationDialog = ({ open, selectedItems, onClose, onConfirm, plans }) => {
  const [currentEmailIndex, setCurrentEmailIndex] = useState(0);
  const [confirmedEmails, setConfirmedEmails] = useState([]);
  const [notes, setNotes] = useState({});
  const [resetNoteFlag, setResetNoteFlag] = useState(false);

  useEffect(() => {
    if (!open) {
      setCurrentEmailIndex(0);
      setConfirmedEmails([]);
      setNotes({});
    }
  }, [open]);

  const handleNoteChange = (index, newNote) => {
    setNotes((prevNotes) => ({
      ...prevNotes,
      [index]: newNote,
    }));
  };

  const handleNext = () => {
    const currentEmail = {
      ...selectedItems[currentEmailIndex],
      note: notes[currentEmailIndex] || '',
    };

    setConfirmedEmails((prevConfirmed) => [...prevConfirmed, currentEmail]);
    setCurrentEmailIndex((prevIndex) => prevIndex + 1);
    setResetNoteFlag((prev) => !prev);
  };

  const handleSkip = () => {
    setCurrentEmailIndex((prevIndex) => prevIndex + 1);
    setResetNoteFlag((prev) => !prev);
  };

  const isVerificationComplete = currentEmailIndex >= selectedItems.length;

  const handleSendAll = () => {
    const emailsToSend = confirmedEmails.map((emailData) => {
      const formattedName = capitalizeWords(`${emailData.first_name} ${emailData.last_name}`);
      const mostRecentCoupon = getMostRecentCoupon(emailData.coupons);
      const uuidForFile = mostRecentCoupon?.uuid;
      const planName =
        plans.find((plan) => plan.uuid === emailData.contract?.uuid_plan)?.name || '';

      const subscriberEmail = emailData.email || emailData.subscriber?.email;
      const normalizedEmail = subscriberEmail && subscriberEmail.trim() !== '' ? subscriberEmail : 'no-user-email@gmail.com';

      return {
        to: normalizedEmail,
        email: normalizedEmail,
        subject: `${planName} - Nro de Orden: ${emailData.contract_number}`,
        text_message: `Estimado ${formattedName}, Nro de Orden:${emailData.contract_number}...`,
        name: formattedName,
        order_number: emailData.contract_number,
        coupons: emailData.coupons,
        plan_name: planName,
        attachment: 'NroOrden1-Año2023-Grupo0.pdf',
        note: emailData.note,
        uuidForFile: uuidForFile,
      };
    });

    onConfirm({ emails: emailsToSend });
    onClose();
  };

  const renderContent = () => {
    if (isVerificationComplete) {
      return (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          Todos los ítems han sido verificados. ¿Enviar los seleccionados?
        </Box>
      );
    }

    return (
      <EmailComposeView
        open={open}
        emailData={selectedItems[currentEmailIndex]}
        plans={plans}
        onNoteChange={(newNote) => handleNoteChange(currentEmailIndex, newNote)}
        resetNoteFlag={resetNoteFlag}
      />
    );
  };

  const renderActions = () => {
    if (isVerificationComplete) {
      return (
        <>
          <CustomButton onClick={onClose} variant="danger">
            Cancelar
          </CustomButton>
          <CustomButton onClick={handleSendAll} variant="base">
            Enviar Todo
          </CustomButton>
        </>
      );
    }

    return (
      <>
        <CustomButton onClick={handleSkip} variant="warning">
          Saltar
        </CustomButton>
        <CustomButton onClick={handleNext} variant="base">
          Siguiente
        </CustomButton>
      </>
    );
  };

  return (
    <DialogContainer open={open} onClose={onClose} size="large">
      <DialogTitle>Confirmar Envío de Emails</DialogTitle>

      <DialogBody>{renderContent()}</DialogBody>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          p: 3,
          borderTop: '1px solid #e0e0e0',
        }}
      >
        {renderActions()}
      </Box>
    </DialogContainer>
  );
};

export default BulkSendConfirmationDialog;
